import { CompanyRelationService } from './integrationSettings';
import TeamLeaderLogo from '../../assets/img/TeamLeaderLogo.png';
import BusinessCentralLogo from '../../assets/img/BusinessCentralLogo.png';
import SAPLogo from '../../assets/img/SAPLogo.png';
import MicrosoftLogo from '../../assets/img/MicrosoftLogo.svg';

export namespace IntegrationSettingsUtil {
  export function companyRelationServiceToString(item: CompanyRelationService): string {
    switch (item) {
      case CompanyRelationService.businessCentral:
        return 'Business Central';
      case CompanyRelationService.sap:
        return 'SAP';
      case CompanyRelationService.teamleader:
        return 'Teamleader';
      case CompanyRelationService.microsoft:
        return 'Microsoft SSO';
    }
  }

  export function integrationSettingsImage(item: CompanyRelationService) {
    switch (item) {
      case CompanyRelationService.businessCentral:
        return BusinessCentralLogo;
      case CompanyRelationService.sap:
        return SAPLogo;
      case CompanyRelationService.teamleader:
        return TeamLeaderLogo;
      case CompanyRelationService.microsoft:
        return MicrosoftLogo;
    }
  }
}
